import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    ViewStyle,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import { theme } from '../constants/theme';

export interface PickerOption {
    label: string;
    value: string;
}

interface CustomPickerProps {
    label: string;
    value: string;
    onValueChange: (value: string) => void;
    options: PickerOption[];
    icon?: string;
    error?: string;
    containerStyle?: ViewStyle;
    placeholder?: string;
}

export const CustomPicker: React.FC<CustomPickerProps> = ({
    label,
    value,
    onValueChange,
    options,
    icon,
    error,
    containerStyle,
    placeholder,
}) => {
    return (
        <View style={[styles.container, containerStyle]}>
            <Text style={styles.label}>{label}</Text>
            <View style={[styles.pickerWrapper, error && styles.pickerWrapper_error]}>
                {icon && (
                    <Icon
                        name={icon}
                        size={20}
                        color={theme.colors.textSecondary}
                        style={styles.icon}
                    />
                )}
                <View style={styles.pickerInner}>
                    <Picker
                        selectedValue={value}
                        onValueChange={onValueChange}
                        style={styles.picker}
                        dropdownIconColor={theme.colors.text}
                    >
                        {placeholder && (
                            <Picker.Item label={placeholder} value="" color={theme.colors.textLight} />
                        )}
                        {options.map((option) => (
                            <Picker.Item
                                key={option.value}
                                label={option.label}
                                value={option.value}
                                color={theme.colors.text}
                            />
                        ))}
                    </Picker>
                </View>
            </View>
            {error && <Text style={styles.error}>{error}</Text>}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginBottom: theme.spacing.md,
    },
    label: {
        ...theme.typography.body2,
        color: theme.colors.text,
        marginBottom: theme.spacing.sm,
        fontWeight: '600',
    },
    pickerWrapper: {
        flexDirection: 'row',
        height: 50,
        alignItems: 'center',
        backgroundColor: theme.colors.surface,
        borderRadius: theme.borderRadius.lg,
        borderWidth: 1,
        borderColor: theme.colors.border,
        paddingHorizontal: theme.spacing.sm,
    },
    pickerWrapper_error: {
        borderColor: theme.colors.error,
    },
    icon: {
        marginRight: theme.spacing.xs,
    },
    pickerInner: {
        flex: 1,
        marginRight: -8,
    },
    picker: {
        marginLeft: -8,
    },
    error: {
        ...theme.typography.caption,
        color: theme.colors.error,
        marginTop: theme.spacing.xs,
    },
});
